import React, { useState } from 'react';
import { ModalPortal } from '@commons/modal-portal/ModalPortal';
import { Overlay } from '@commons/overlay/Overlay';
import closeIcon from '@images/close-icon.svg';
import desktopImageOnTop from '@images/golang-development/why-use-golang/pop-up/desktop-img-on-top.png';
import desktopImageOnBottom from '@images/golang-development/why-use-golang/pop-up/desktop-img-on-bottom.png';
import mobileImageOnTop from '@images/golang-development/why-use-golang/pop-up/mobile-img-on-top.png';
import { ColorButton } from '@pages-impl/golang-development/common/ColorButton';
import { GolangForm } from './pop-up/GolangForm';
import { checklistDataForm } from './payload';

import * as styles from './download-checklist-form.module.scss';

export const DownloadChecklistForm = ({ showForm, setShowForm }) => {
  const formData = checklistDataForm;

  const [formSubmitted, setFormSubmitted] = useState(false);

  function closeForm(e) {
    e.preventDefault();
    setShowForm(false);
  }

  function runSetFormSubmitted() {
    setFormSubmitted(true);
  }

  return (
    <ModalPortal>
      {showForm && (
        <>
          <Overlay />
          {formSubmitted ? (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.headerImage}>
                  <img loading="lazy" src={desktopImageOnTop} alt="Top image" />
                </div>
                <div className={styles.headerImageMobile}>
                  <img loading="lazy" src={mobileImageOnTop} alt="Top image" />
                </div>
                <div className={styles.headerDescription}>
                  <h3>{formData.thankYouTitle}</h3>
                  <p>{formData.thankYouNote}</p>
                </div>
                <button className={styles.closeBtn} onClick={closeForm}>
                  <img loading="lazy" src={closeIcon} alt="Close icon" />
                </button>
              </div>
              <ColorButton label="Close" className={styles.thankYouCloseButton} onClick={closeForm} />
              <div className={styles.bottomImage}>
                <img loading="lazy" src={desktopImageOnBottom} alt="Bottom image" />
              </div>
            </div>
          ) : (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.headerImage}>
                  <img loading="lazy" src={desktopImageOnTop} alt="Top image" />
                </div>

                <div className={styles.headerImageMobile}>
                  <img loading="lazy" src={mobileImageOnTop} alt="Top image" />
                </div>

                <div className={styles.headerDescription}>
                  <h3>{formData.mainTitle}</h3>
                  <p>{formData.description}</p>
                </div>
                <button className={styles.closeBtn} onClick={closeForm}>
                  <img loading="lazy" src={closeIcon} alt="Close icon" />
                </button>
              </div>
              <div className={styles.hubspot} id="golangDownloadForm">
                <GolangForm runSetFormSubmitted={runSetFormSubmitted} />
              </div>
              <div className={styles.bottomImage}>
                <img loading="lazy" src={desktopImageOnBottom} alt="Bottom image" />
              </div>
            </div>
          )}
        </>
      )}
    </ModalPortal>
  );
};
